import { redzones } from './paramTypes';

export const isSuperset = block => {
    return block.exerciseKeys.length > 1 && block.plain_text !== 1;
};

export const hasLeaderboard = block => {
    return block.redzone_type !== redzones.COMPLETION;
};
